import React from 'react';
import Link from 'next/link';
import { useTranslations } from '../../locales/useTranslations';

const QR_FLOW_URL = 'https://qr-flow.eu';

const QrFlowCta = () => {
    const { t } = useTranslations();

    return (
        <section className="qr-flow-cta">
            <div className="container">
                <div className="qr-flow-cta__box">
                    <h2>{t('qrFlow_cta_title')}</h2>
                    <p>{t('qrFlow_cta_description')}</p>
                    <div className="qr-flow-cta__buttons">
                        <a
                            href={`${QR_FLOW_URL}/register/`}
                            className="qr-flow-cta__btn-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {t('qrFlow_cta_primary')}
                        </a>
                        <Link href="/kontakt/" className="qr-flow-cta__btn-secondary">
                            {t('qrFlow_cta_secondary')}
                        </Link>
                    </div>
                    <p className="qr-flow-cta__note">
                        {t('qrFlow_cta_note')}{' '}
                        <a href={QR_FLOW_URL} target="_blank" rel="noopener noreferrer">
                            qr-flow.eu
                        </a>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default QrFlowCta;
